/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  GET_CONTACT_CATEGORIES_LIST,
  GET_CONTACT_CATEGORIES_LIST_SUCCESS,
  GET_CONTACT_CATEGORIES_LIST_ERROR,
  GET_CONTACT_CATEGORY,
  GET_CONTACT_CATEGORY_SUCCESS,
  GET_CONTACT_CATEGORY_ERROR,
  CREATE_CONTACT_CATEGORY,
  CREATE_CONTACT_CATEGORY_SUCCESS,
  CREATE_CONTACT_CATEGORY_ERROR,
  UPDATE_CONTACT_CATEGORY,
  UPDATE_CONTACT_CATEGORY_SUCCESS,
  UPDATE_CONTACT_CATEGORY_ERROR,
  CHANGE_CONTACT_CATEGORY_STATUS,
  CHANGE_CONTACT_CATEGORY_STATUS_SUCCESS,
  CHANGE_CONTACT_CATEGORY_STATUS_ERROR,
  DELETE_CONTACT_CATEGORY,
  DELETE_CONTACT_CATEGORY_SUCCESS,
  DELETE_CONTACT_CATEGORY_ERROR,
  CLEAR_CONTACT_CATEGORY_WAS_DELETED,
  CLEAR_CONTACT_CATEGORIES_LIST,
  CLEAR_CONTACT_CATEGORY_DETAILS,
  SET_CURRENT_NAVIGATION_TAB,
  SET_CONTACT_CATEGORY_DETAILS_VIEW_TAB,
  SET_CONTACT_CATEGORIES_QUERY,
  SET_BACK_TO_CATEGORIES_LIST,
  SET_SELECTED_CONTACT_CATEGORIES,
} from 'src/actions/contactSettingsActions';

const initialCurrentNavigationTab = 'categories';
const initialCategoryDetailsCurrentNavigationTab = 'details';
const backToCategoriesList = {
  categories: [],
  query: {},
  active: false,
  comeBack: false,
};

const initialState = {
  currentNavigationTab: initialCurrentNavigationTab,
  categories: [],
  selectedContactCategories: [],
  query: {
    sort: [['name', 'asc']],
    page: 1,
    pageSize: 50,
    count: 0,
  },
  categoryDetails: {
    currentNavigationTab: initialCategoryDetailsCurrentNavigationTab,
    category: {},
    categoryWasDeleted: false,
    loading: false,
  },
  loading: false,
  backToCategoriesList,
};

const contactSettingsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_CONTACT_CATEGORIES_LIST: {
      return produce(state, (draft) => {
        draft.loading = true;
      });
    }

    case GET_CONTACT_CATEGORIES_LIST_SUCCESS: {
      return produce(state, (draft) => {
        draft.categories = payload?.data || [];
        draft.query.count = payload?.count || 0;
        draft.loading = false;
      });
    }

    case GET_CONTACT_CATEGORIES_LIST_ERROR: {
      return produce(state, (draft) => {
        draft.loading = false;
        draft.query.count = 0;
      });
    }

    case GET_CONTACT_CATEGORY:
    case CREATE_CONTACT_CATEGORY:
    case UPDATE_CONTACT_CATEGORY:
    case CHANGE_CONTACT_CATEGORY_STATUS: {
      return produce(state, (draft) => {
        draft.categoryDetails.loading = true;
      });
    }

    case GET_CONTACT_CATEGORY_SUCCESS: {
      return produce(state, (draft) => {
        draft.categoryDetails.category = payload || {};
        draft.categoryDetails.loading = false;
      });
    }

    case GET_CONTACT_CATEGORY_ERROR:
    case CREATE_CONTACT_CATEGORY_SUCCESS:
    case CREATE_CONTACT_CATEGORY_ERROR:
    case UPDATE_CONTACT_CATEGORY_SUCCESS:
    case UPDATE_CONTACT_CATEGORY_ERROR:
    case CHANGE_CONTACT_CATEGORY_STATUS_SUCCESS:
    case CHANGE_CONTACT_CATEGORY_STATUS_ERROR: {
      return produce(state, (draft) => {
        draft.categoryDetails.loading = false;
      });
    }

    case DELETE_CONTACT_CATEGORY: {
      return produce(state, (draft) => {
        draft.loading = true;
        draft.categoryDetails.loading = true;
      });
    }

    case DELETE_CONTACT_CATEGORY_SUCCESS: {
      const { cancelRedirectToCategoriesList } = payload;
      return produce(state, (draft) => {
        draft.categoryDetails.loading = false;
        draft.loading = false;
        if (!cancelRedirectToCategoriesList) {
          draft.categoryDetails.categoryWasDeleted = true;
        }
      });
    }

    case DELETE_CONTACT_CATEGORY_ERROR: {
      return produce(state, (draft) => {
        draft.categoryDetails.loading = false;
        draft.loading = false;
      });
    }

    case CLEAR_CONTACT_CATEGORIES_LIST: {
      return produce(state, (draft) => {
        draft.categories = initialState.categories;
      });
    }

    case CLEAR_CONTACT_CATEGORY_DETAILS: {
      return produce(state, (draft) => {
        draft.categoryDetails.category = {};
      });
    }

    case CLEAR_CONTACT_CATEGORY_WAS_DELETED: {
      return produce(state, (draft) => {
        draft.categoryDetails.categoryWasDeleted = false;
      });
    }

    case SET_CURRENT_NAVIGATION_TAB: {
      return produce(state, (draft) => {
        draft.currentNavigationTab = payload || initialCurrentNavigationTab;
      });
    }

    case SET_CONTACT_CATEGORY_DETAILS_VIEW_TAB: {
      return produce(state, (draft) => {
        draft.categoryDetails.currentNavigationTab = payload || initialCategoryDetailsCurrentNavigationTab;
      });
    }

    case SET_CONTACT_CATEGORIES_QUERY: {
      return produce(state, (draft) => {
        draft.query = payload ? {
          ...state.query,
          ...payload
        } : initialState.query;
      });
    }

    case SET_BACK_TO_CATEGORIES_LIST: {
      return produce(state, (draft) => {
        draft.backToCategoriesList = payload ? {
          ...state.backToCategoriesList,
          ...payload,
        } : backToCategoriesList;
      });
    }

    case SET_SELECTED_CONTACT_CATEGORIES: {
      return produce(state, (draft) => {
        draft.selectedContactCategories = payload || [];
      });
    }

    default: {
      return state;
    }
  }
};

export default contactSettingsReducer;
